"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFormula = void 0;
class TypeFormula {
    constructor(name, typeParameters, metadata) {
        this.name = name;
        this.typeParameters = typeParameters;
        this.metadata = metadata;
    }
    toString() {
        const hasTypeParameters = this.typeParameters.length > 0;
        const typeParameters = hasTypeParameters
            ? `<${this.typeParameters.map((tp) => tp.toString()).join(", ")}>`
            : "";
        const baseName = `${this.name}${typeParameters}`;
        return this.metadata !== undefined ? `${baseName}*${this.metadata}*` : baseName;
    }
}
exports.TypeFormula = TypeFormula;
//# sourceMappingURL=typeFormula.js.map